export default {
  'component.securityScheme.formItemName.authorizationType': 'Authorization Type',
  'component.securityScheme.apiKeyFormItem.name.label': 'Name',
  'component.securityScheme.allowedSecuritySchemes': 'Allowed Security Scheme',
  'component.securityScheme.preview.title': 'Security Scheme',
  'component.securityScheme.optional': 'Make Security Optional',
  'component.securityScheme.inheritFrom': 'Inherited from parent folder',
  'component.securityScheme.noAuthDesc': 'No authentication required',
  'component.securityScheme.useCase.empty-alert':
    'The security scheme referenced by this endpoint has been deleted. Please modify the authentication configuration of this endpoint.',
};
